<template>
  <b-row>
    <b-col class="mb-2 d-flex align-items-center justify-content-between" cols="12">
      <h1 class="mb-0">Клиентский портфель</h1>
      <ClientFinanceExportButton />
    </b-col>

    <b-col cols="12" class="mb-3">
      <tsoft-wrapper>
        <ClientPortfolioActions />
      </tsoft-wrapper>
    </b-col>

    <b-col cols="12">
      <tsoft-wrapper :loading="summaryLoading">
        <ClientPortfolioChart :data="summary" />
      </tsoft-wrapper>
    </b-col>

    <b-col cols="12" class="mt-3">
      <tsoft-wrapper>
        <ClientPortfolioTable
          server-side
          :tableData="tableData"
          :tableFields="tableFields"
          :busy="tableLoading"
          :error="tableError"
          :total="total"
          :page="page"
          :perPage="perPage"
          :sortBy="sortBy"
          :sortDesc="sortDesc"
          :search="search"
          @page-change="setPage"
          @per-page-change="setPerPage"
          @sort-changed="setSort"
          @search="setSearch"
          @retry="loadTable"
        />
      </tsoft-wrapper>
    </b-col>

    <ClientPortfolioSubcompaniesModal />
  </b-row>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import ClientPortfolioTable from "@components/clientPortfolio/ClientPortfolioTable.vue";
import ClientPortfolioChart from "@components/clientPortfolio/ClientPortfolioChart.vue";
import ClientPortfolioActions from "@components/clientPortfolio/ClientPortfolioActions.vue";
import ClientPortfolioSubcompaniesModal from "@components/clientPortfolio/ClientPortfolioSubcompaniesModal";
import ClientFinanceExportButton from "@components/clientPortfolio/ClientFinanceExportButton.vue";
export default {
  components: {
    ClientPortfolioChart,
    ClientPortfolioTable,
    ClientPortfolioActions,
    ClientPortfolioSubcompaniesModal,
    ClientFinanceExportButton,
  },

  data() {
    return {
      tableFields: [
        {
          label: "ID",
          key: "id",
          rowspan: "1",
          sortable: true,
          stickyColumn: true,
          visible: false,
          thStyle: {
            width: "50px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },
        {
          label: "Имя компании",
          sortable: true,
          stickyColumn: true,
          key: "name",
        },
        {
          label: "Статус",
          sortable: true,
          key: "status_name",
          thStyle: {
            width: "170px",
          },
        },
        {
          label: "Риск",
          sortable: true,
          key: "is_at_risk",
          thStyle: {
            width: "80px",
          },
        },
        {
          label: "Первая поставка",
          sortable: true,
          key: "first_shipment_date",
          formatter: (value) => {
            if (!value) {
              return "";
            }
            const [year, month, day] = value.split("-");
            return `${day}.${month}.${year}`;
          },
          thStyle: {
            width: "130px",
          },
          tdAttr: {
            "data-t": "d",
          },
        },
        {
          label: "Последняя поставка",
          sortable: true,
          key: "last_shipment_date",
          formatter: (value) => {
            if (!value) {
              return "";
            }
            const [year, month, day] = value.split("-");
            return `${day}.${month}.${year}`;
          },
          thStyle: {
            width: "130px",
          },
          tdAttr: {
            "data-t": "d",
          },
        },
        {
          label: "Последний комментарий",
          sortable: false,
          key: "last_comment",
        },
        {
          label: "Менеджер ТО",
          sortable: true,
          key: "to_manager_name",
        },
        {
          label: "Менеджер ТЭО",
          sortable: true,
          key: "teo_manager_name",
        },
        {
          label: "Sales Менеджер",
          sortable: true,
          key: "sales_manager_name",
        },
        {
          label: "ИНН",
          key: "inn",
          sortable: true,
          thStyle: {
            width: "150px",
          },
        },
        {
          label: "Источник",
          key: "source_name",
          sortable: true,
          thStyle: {
            width: "150px",
          },
        },
        {
            label: "Последняя заявка",
            key: "last_created_order",
            sortable: true,
            sortByFormatted: true,
            formatter: (value) => {
                if (value) {
                const date = new Date(value);
                return new Intl.DateTimeFormat('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                }).format(date);
                }
                return "";
            },
            thStyle: {
                width: "150px",
            },
            tdAttr: {
                "data-t": "d",
            },
        },
        {
          label: "1 месяц",
          key: "1_month",
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => value.length,
          thStyle: {
            width: "100px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },        
        {
          label: "3 месяцa",
          key: "3_month",
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => value.length,
          thStyle: {
            width: "100px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },
        {
          label: "6 месяц",
          key: "6_month",
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => value.length,
          thStyle: {
            width: "100px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },
        {
          label: "1 год",
          key: "1_year",
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => value.length,
          thStyle: {
            width: "100px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },
        {
          label: "Все",
          key: "all",
          sortable: true,
          sortByFormatted: true,
          formatter: (value) => value.length,
          thStyle: {
            width: "100px",
          },
          tdAttr: {
            "data-t": "n",
          },
        },
      ],
    };
  },

  watch: {
    // Компанию отредактировали в боковой панели - обновить строку, если она на текущей странице
    companyWidgetValue(value) {
      const updated_item = this.tableData.find(item => item.id === value.id);
      if (!updated_item) {
        return;
      }
      updated_item.name = value.name;
      updated_item.last_comment = value.last_comment;
      updated_item.to_manager_name = value.to_manager_name;
      updated_item.sales_manager_name = value.sales_manager_name;
      updated_item.inn = value.inn;
    },
  },

  computed: {
    ...mapState("clientPortfolio", ["summary", "total", "page", "perPage", "sortBy", "sortDesc", "search"]),
    ...mapGetters("clientPortfolio", ["tableData", "summaryLoading", "tableLoading", "tableError"]),
    ...mapGetters('companyDetail', ['companyWidgetValue']),
  },

  methods: {
    ...mapActions("clientPortfolio", ["init", "loadTable", "setPage", "setPerPage", "setSort", "setSearch"]),
  },

  mounted() {
    this.init();
  },
};
</script>
